import type { RootState } from '@/store';

export const accountSelector = (state: RootState) => state.account.account;
export const accountGroupSelector = (state: RootState) => state.account.selectedGroup;
export const accountGroupNameSelector = (state: RootState) => state.account.selectedGroupName;
export const sideMenuPathSelector = (state: RootState) => state.account.sideMenuActivePath;
export const receptionCenterSelector = (state: RootState) => state.account.selectedReceptionCenter;
export const selectedRCSelector = (state: RootState) => state.account.selectedReceptionCenter;
